import { render, staticRenderFns } from "./RequiresSitePermissions.vue?vue&type=template&id=616913da&"
import script from "./RequiresSitePermissions.vue?vue&type=script&lang=js&"
export * from "./RequiresSitePermissions.vue?vue&type=script&lang=js&"
import style0 from "./RequiresSitePermissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports